import React, { useEffect, useRef, useState } from "react";
import api from "../../seller-apis/api";
import '../order.css';
import { useAlert } from "react-alert";
import { NavLink } from 'react-router-dom';
import { fetchOpportunityData, pdetailData } from '../../seller-apis/apidataField';
import PaginationNew from "../common/Pagination";
import servicesApi from '../../seller-apis/servicesApi';
import Popup from '../common/Popup';
import UpdtProPopup2 from '../common/UpdtProPopup2';
import OrderSKUSearch from "../common/ProductSearch/OrderSKUSearch";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { Form, Modal, Row } from "react-bootstrap";

import WeightComponent from "../common/WeightComponent";
import { useDispatch, useSelector } from 'react-redux';
import { resetPackages, setInitialPackages, setReferencePackage } from '../../Actions/PackageWeight';
import { packagesCmtoFt, packagesFttoCm } from '../../utilities/conversion';
import variables from '../../Variables.json'
import SuccessPopup from "../common/SuccessPopup";
import MainLoader from "../common/Loader/PageLoader";
import { Actions } from "../../Actions/Actions";

var globalFilterData = {
  pageNo: 1,
  size: 12,
  filters: {
  },
  sortFilter: { "createdAt": -1 },
};

//searchParam
var searchParam = {

  // "status": "pending"
};
var productsDetails = {};
const normalizeRecommendedProduct = (product) => {
  const productData = product?.productId || product;
  const combinationSet = Array.isArray(product?.combinationSet)
    ? product.combinationSet
    : product?.combinationSet
      ? [product.combinationSet]
      : [];

  const productForUi = {
    ...productData,
    images: productData?.images || product?.images || [],
    combination: productData?.combination || product?.combination || [],
  };

  return {
    ...product,
    productId: productForUi,
    productName: product?.productName || productData?.productName,
    SKU: product?.SKU || productData?.SKU,
    images: product?.images || productData?.images || [],
    combinationSet,
    expTransferPriceFrom: product?.expTransferPriceFrom || product?.transferPrice || product?.price,
    expTransferPriceTo: product?.expTransferPriceTo || product?.transferPrice || product?.price,
  };
};

function ProductOpportunities() {
  const alert = useAlert();
  const [showModal, setShowModal] = useState(false);
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [tickets, setTickets] = useState([]);
  var currentDate = new Date();

  // Get the date before 15 days
  var before15Days = new Date();
  before15Days.setDate(currentDate.getDate() - 30);

  // Format the dates as strings (optional)
  var currentDateStr = currentDate.toISOString().split("T")[0];
  var before15DaysStr = before15Days.toISOString().split("T")[0];
  const [sortdatefrom, setsortdatefrom] = useState(before15DaysStr);
  const [sortdateto, setsortdateto] = useState(currentDateStr);
  const [minValDate, setMinValDate] = useState("2023-08-01");
  const [orderId, setOrderId] = useState("");
  const [totalRcord, setTotalReord] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsMessage, setRecordsMessage] = useState("No data found");
  const statusCheck = ['open', 'reopen', 'repene'];
  // const [showAddPopup, setShowAddPopup] = useState("block");
  const [cbimg, setcbimg] = useState();
  const [selectedProductPopup, setselectedProductPopup] = useState();
  const [updtProVisibility, setupdtProVisibility] = useState(false);
  const [clickedUpdateNo, setclickedUpdateNo] = useState();
  const [updtPopuprel, setupdtPopuprel] = useState([]);
  const [otherSellerPrice, setotherSellerPrice] = useState();
  const [opportunityId, setOpportunityId] = useState(null);
  const [searchPro, setsearchPro] = useState();
  const [searchType, setSearchType] = useState("Product Name");
  const [ennewloader, setennewloader] = useState("none");
  const outerdivRef = useRef(null);
  const loaderDivRef = useRef(null);
  const history = useHistory();
  // const [reviewImages, setReviewImages] = useState([]);
  // const [reviewVideos, setReviewVideos] = useState([]);
  // const handleOpenModal = () => {
  //   setShowModal(true);
  // };

  const [verifyManifestPopup, setVerifyManifestPopup] = useState(false);
  const [currentClickedOrder, setCurrentClickedOrder] = useState(null);
  const [currentStep, setCurrentStep] = useState(0)
  const [tpDisabled, setTpDisabled] = useState(true)
  const [stockDisabled, setStockDisabled] = useState(true)
  const [verTrPrice, setVerTrPrice] = useState(null)
  const [currentStock, setCurrentStock] = useState(null)
  const [clickedProDets, setClickedProDets] = useState()
  const [weightChangeStatus, setWeightChangeStatus] = useState("")

  const [gst, setGst] = useState("")
  const dispatch = useDispatch()

  // For showing success message
  const [isSuccessPopupVisible, setIsSuccessPopupVisible] = useState(false);


  // sl-758(1-9-2025)
  const [curCombinationKeys, setCurCombinationKeys] = useState([]);
  const [curCombinationValues, setCurCombinationValues] = useState([]);

  const handleCloseModal = () => {
    setShowModal(false);
    setShowRequestModal(false);
  };

  function applyLoader() {
    if (loaderDivRef.current && outerdivRef.current) {
      loaderDivRef.current.classList.add("loader-bt");
      setennewloader("flex");
      outerdivRef.current.classList.add("div-bk");
    }
  }

  function removeLoader() {
    if (loaderDivRef.current && outerdivRef.current) {
      setennewloader("none");
      loaderDivRef.current.classList.remove("loader-bt");
      outerdivRef.current.classList.remove("div-bk");
    }
  }

  // sl -758
  useEffect(() => {
    if (!verifyManifestPopup) {
      dispatch(resetPackages())
      setTpDisabled(true)
      setStockDisabled(true)
      setCurrentStock(null)
      setVerTrPrice(null)
      setCurrentStep(0)
    }
  }, [verifyManifestPopup])

  useEffect(() => {
    // let filterData = globalFilterData;

    // globalFilterData.filter["from-createdAt"] = sortdatefrom + "T00:00:00";
    // globalFilterData.filter["to-createdAt"] = sortdateto + "T23:59:59";
    if (window.location.hash === '#popupDetail') {
      history.replace(window.location.pathname); // Replace the current URL
    }
    globalFilterData = {
      pageNo: 1,
      size: 12,
      filters: {
      },
      sortFilter: { "createdAt": -1 },
    };
    getOpportunity(globalFilterData)
  }, []);

  const getOpportunity = (filterData) => {
    applyLoader();
    setRecordsMessage("No data found");
    api.Opportunity.getRecommendedProducts(fetchOpportunityData(filterData))
      .then((review) => {
        Actions.updateRecommendedProductOpportunityCount(dispatch, review.totalRecords);
        setTotalReord(review.totalRecords);
        // const trueValues = [];
        // const falseValues = [];
        let data = review.data?.map(normalizeRecommendedProduct) || [];
        // // Iterate through the original array and separate objects based on status
        // data.forEach(item => {
        //   if (item.adminMsgInfo?.vendorViewed) {
        //     trueValues.push(item);
        //   } else {
        //     falseValues.push(item);
        //   }
        // });
        // const reorderedData = falseValues.concat(trueValues);
        setTickets(data);
      })
      .catch((err) => {
        console.log(err);
        setTickets([]);
        setTotalReord(0);
        Actions.updateRecommendedProductOpportunityCount(dispatch, 0);
        setRecordsMessage("No records fetched");
      })
      .finally(() => {
        removeLoader();
      });
  };
  const dateFilter = (e) => {
    if (sortdatefrom === undefined || sortdateto === undefined || sortdateto === "" || sortdatefrom === "") {
      alert.show("please select both date");
    }
    else {
      let filterData = globalFilterData;

      filterData.filter["from-createdAt"] = sortdatefrom + "T00:00:00";
      filterData.filter["to-createdAt"] = sortdateto + "T23:59:59";

      getOpportunity(filterData);
    }
  };
  // const applyFilter = (data) => {
  //   let filterData = globalFilterData;
  //   if (data != "all") {
  //     filterData.filter["status.label"] = data;
  //   } else {
  //     filterData.filter["status.label"] = "";
  //   }
  //   getOpportunity(filterData);
  // };

  function paginate(data) {
    setCurrentPage(data.number);

    globalFilterData['pageNo'] = data.number;
    getOpportunity(globalFilterData);
  }

  // For detail of product
  const detailnew = (id, price, index) => {

    let data =
    {
      "filter": { "_id": id }
    }
    setCurCombinationValues(tickets[index]?.combinationSet || [])
    setCurCombinationKeys(tickets?.[index]?.productId?.combination[0]?.value)
    servicesApi.getProductDetail(data).then((res) => {
      detail([res.data], price)
      setpopupVisibilityDetail("2");
    }).catch(err => console.log(err))

  }

  // For detail of product
  // const mediaView = (mediaArr) => {
  //   let images = [];
  //   let videos = [];
  //   mediaArr.forEach(med => {
  //     if (med.image) {
  //       images.push(med);
  //     } else {
  //       videos.push(med);
  //     }
  //   });
  //   setReviewImages(images);
  //   setReviewVideos(videos);
  //   setMediaPopupVis("block");
  // }

  //Product Detail Popup

  const [productDetail, setproductDetail] = useState([
    {
      "description": undefined,
      "sdescription": undefined,
      "name": undefined,
      "price": undefined,
      "SKU": undefined,
      "popupVisibility": undefined,
      "images": []
    }
  ]);
  const [isDetailPopupVis, setisDetailPopupVis] = useState("block");
  const [mediaPopupVis, setMediaPopupVis] = useState("block");
  const [detailPPrice, setdetailPPrice] = useState("");
  // Popup showing detail
  function detail(data, price) {
    setdetailPPrice(price)
    console.log(data)
    if (data && data[0] === undefined) {
      setproductDetail(
        [
          {
            "description": "No details available",
            "sdescription": "No short description",
            "name": undefined,
            "price": undefined,
            "SKU": undefined,
            "popupVisibility": undefined,
            "images": []
          }
        ]
      )
    }
    else {
      setproductDetail(data)
    }
  }

  //Popup related functions
  function setpopupVisibilityDetail(e) {
    if (e) {
      setisDetailPopupVis("block")
    }
    else {
      setisDetailPopupVis("none")
    }
  }

  //Media popup related functions
  function setMediaPopupVisibilityDetail(e) {
    if (e) {
      setMediaPopupVis("block")
    }
    else {
      setMediaPopupVis("none")
    }
  }

  // Check response of product added
  function callbackResponse(msg) {
    if (msg === "product added" || msg === "product updated") {
      setupdtProVisibility(false);
      alert.success("Product Added Successfully");
      if (opportunityId !== null) {
        api.Opportunity.deleteOpportunity(opportunityId).then(res => {
          // console.log("Opportunity res: ", res);
        }).catch((err) => console.log(err));
      }
      getOpportunity(globalFilterData);
    }
    else {
      setupdtProVisibility(false)
      alert.error("Product not added")
    }
  }

  function checkpopupvisibility(e) {
    if (e === false) {
      setupdtProVisibility(false)
    }
    else {
      setupdtProVisibility(true)
    }
  }

  //set add this product popup show issue
  function handleAddProduct(img, ticket) {
    let pkgs = [];
    ticket?.pkgs?.forEach(element => {
      pkgs.push(element?.pkg[0])
    });
    setupdtPopuprel({
      "SKU": ticket.SKU,
      "taxClass": ticket.taxClass,
      "pkgs": pkgs,
      "categories": ticket.categories
    });
    productsDetails = {
      "SKU": ticket.SKU,
      "taxClass": ticket.taxClass,
      "pkgs": pkgs,
      "categories": ticket.categories
    };
    setcbimg(img);
    setselectedProductPopup(ticket.productName);
    setclickedUpdateNo(ticket.productId);
    setOpportunityId(ticket._id);
    setupdtProVisibility(true);
    setotherSellerPrice(ticket.onClick);
  }

  const filterSearch = (data) => {

    setsearchPro(data.data);
    setSearchType(data.type)

    //productId-objectId filed set
    if (data.type == "sku") {
      globalFilterData['filters'] = { ...globalFilterData.filters, "_id-objectId": data.data }
    }
    else {
      globalFilterData['filters'] = { ...globalFilterData.filters, "_id-objectId": data.data }
    }
    //Search Issue on Other than 1st Page SL-698 and SL-675
    globalFilterData.pageNo = 1;
    setCurrentPage(1);
    getOpportunity(globalFilterData);
    // console.log(globalFilterData)
    //SL-698
    if (globalFilterData?.filters && globalFilterData['filters']['_id-objectId'])
      delete globalFilterData['filters']['_id-objectId'];
  }

  const ApiCalling = () => {

    globalFilterData = {
      pageNo: currentPage,
      size: 12,
      filters: {
      },
      sortFilter: { "createdAt": -1 },
    };
    getOpportunity(globalFilterData)
  }

  // sl-758
  const manifestDetailsVerify = (index, step = null) => {
    setCurrentClickedOrder(tickets[index])
    setGst(tickets[index]?.productId?.taxClass)
    if (step !== null) setCurrentStep(step)
    let data =
    {
      "filter": { "_id": tickets[index]?.productId?._id }
    }
    setCurCombinationValues(tickets[index]?.combinationSet || [])
    setCurCombinationKeys(tickets?.[index]?.productId?.combination[0]?.value)
    servicesApi.getProductDetail(data).then((res) => {
      setClickedProDets(res?.data)
      setVerifyManifestPopup(true)
      dispatch(setInitialPackages(res?.data?.pkgs))
      console.log(data)
    }).catch(err => console.log(err))
  }


  const verManifestValidation = {
    step1: () => {
      if (verTrPrice === undefined || verTrPrice === null || verTrPrice < 1) {
        alert.info('Please enter a valid transfer price.')
        return false;
      }
      else if (verTrPrice > currentClickedOrder?.expTransferPriceTo) {
        alert.info('Transfer price should be less than expected transfer price')
        return false;
      }
      return true;
    },
    step2: () => {
      if (currentStock === undefined || currentStock === null || currentStock < 1 || currentStock === "") {
        alert.info('Please enter a valid stock.')
        return false;
      }
      return true;
    }
  }


  const submitVerifyManifest = async () => {
    const isValidStep2 = verManifestValidation.step2()
    if (!isValidStep2) return;
    try {
      // 0
      let tpData = {}
      if (currentClickedOrder?.combinationSet?.[0]?.url) {
        tpData = {
          _id: currentClickedOrder?.productId?._id,
          taxClass: gst,
          combination: { "url": currentClickedOrder?.combinationSet[0]?.url, "purchase_price": verTrPrice, "sellerWeightChangeSts": "T_PENDING", "stock": currentStock }
        }
      }
      else {
        tpData = {
          _id: currentClickedOrder?.productId?._id,
          taxClass: gst,
          purchase_price: verTrPrice,
        }
      }
      tpData["receivedFrom"] = "similar products"
      tpData["stock"] = currentStock;
      // sl-758 (1-9-25)
      tpData["status"] = "PENDING";
      await api.product.addToExProduct(tpData)

      // update recommended product
      let updateBody = {
        "_id": currentClickedOrder?._id,
        "status": "done",
        "productName": currentClickedOrder?.productName,
        "SKU": currentClickedOrder?.SKU,
        "productId": currentClickedOrder?.productId?._id
      }
      await api.Opportunity.updateRecommendedProduct(updateBody)
      alert.success("updated")
      setCurrentStep(0)
      setVerifyManifestPopup(false)
      setWeightChangeStatus(null)
      setIsSuccessPopupVisible(true)
      getOpportunity(globalFilterData)
    } catch (err) {
      alert.error(err)
    }
  }


  const handleModalGoBack = (step) => {
    if (step < currentStep) {
      setCurrentStep(step)
    }
  }

  // sl-758
  const handlePriceSubmit = () => {
    const isValidStep1 = verManifestValidation.step1()
    if (!isValidStep1) return
    setCurrentStep(2)
  }

  const styles = {
    verifyManifestPopup: {
      headerDiv: {
        display: 'flex',
        width: '100%'
      },
      expTraPriceTag: {
        // background: 'red',
        // width: 'fit-content',
        margin: 'auto',
        // padding: '2px 20px',
        color: 'red',
        // marginBottom: '13px'

      },
      headerBtns: {
        flex: 1,
        border: 'none',
        boxShadow: '0px 1px 0px 0.5px grey',
        padding: '4px 0px',
        fontSize: "14px"
      },
      vtpPara: {
        textAlign: 'left',
        fontSize: '16px',
        fontWeight: "bold"
      },
      imageBox: {
        height: "98px"
      },
      pName: {
        textAlign: 'left',
        fontSize: '16px',
      },
      sku: {
        textAlign: 'left',
      },
      confirmBtn: {

      },
      label: {
        display: 'flex',
        justifyContent: 'center'
      },
      tpInput: {
        width: "100px",
        padding: '2px 23px 2px 11%',
        fontWeight: 'bold',
        letterSpacing: '0.5px',
      },
      gstInput: {
        fontSize: "10px",
        padding: "2px 10px",
        width: "100px"
      },
      rsLabel: {
        position: 'absolute',
        top: '3px',
        left: '2%',
        // fontWeight:'800 !important'
      },
      tpTitle: {
        color: 'black',
        // sl-758
        width: '40%',
        textAlign: 'right'
      },
      sUpdateContainer: {
        // width: '50%',
        width: '30%',
        textAlign: 'left',
      },
      cStockTitle: {
        position: 'absolute',
        transform: 'translateY(-50%)',
        top: '0px',
        marginLeft: '12px',
        zIndex: 1,
        padding: '0px 4px',
        background: 'white',
      },
      cStockInput: {
        width: "100px",
        padding: '2px 23px 2px 2%',
        fontWeight: 'bold',
        letterSpacing: '0.5px',
      },
      endBtnContainer: {
        textAlign: 'end',
        marginTop: '40px'
      },
      submitBtn: {
        color: '#fff',
        background: '#165b5b',
        borderRadius: '4px',
        padding: "4px 20px",
        borderStyle: 'none',
        fontSize: '15px',
        boxShadow: '0 .2em 1em -.2em #d0d0d0'
      },
      backBtn: {
        color: 'white',
        background: '#909090',
        borderRadius: '4px',
        padding: "4px 15px",
        borderStyle: 'none',
        fontSize: '15px',
        boxShadow: '0 .2em 1em -.2em #d0d0d0',
      },
      tpEdit: {
        top: '3px',
        position: 'absolute',
        right: '127px',
        cursor: 'pointer'
      },
      stockEdit: {
        top: '-1px',
        position: 'absolute',
        right: '2px',
        cursor: 'pointer'
      },
    }
  }
 
//<Start-Here> On enter implement search | Ticket : SL-990 
/**
 * Search By Keyword On Enter
 */
const searchByKeyword = (value, type, productIds) => {
    if (productIds.length > 0) {
      globalFilterData['searchIds'] = productIds
      globalFilterData.pageNo = 1;
      setCurrentPage(1);
      getOpportunity(globalFilterData);
    }
    else {
      setTickets([]);
      setTotalReord(0);
    }
}
//</End-Here> On enter implement search | Ticket : SL-990
  return (
    <div>
      {/* <div className="d-flex mb-3 justify-content-start">
        <div className="theme-shed1 p-2">
          <div className="m-auto mt-1">
            <span className="payment_dates">
              From: -{" "}
              <input
                type="date"
                min={minValDate}
                value={sortdatefrom}
                onChange={(e) => setsortdatefrom(e.target.value)}
              ></input>
            </span>
            <span className="mx-2 payment_dates">
              To: -{" "}
              <input
                type="date"
                min={minValDate}
                value={sortdateto}
                onChange={(e) => setsortdateto(e.target.value)}
              ></input>
            </span>
            <span>
              <button
                className="apply-btn px-3 py-1 ff_Pop fs-14"
                onClick={() => dateFilter()}
              >
                Apply
              </button>
            </span>
          </div>
        </div>
      </div> */}
      < div className="table-responsive" >
        <table className="ord_table new-table-design" style={{ "width": "100%" }}>
          <thead>
            <tr>
              <th>
                Product Image
              </th>
              <th style={{ width: '60%' }}>
                Product Details
                <div className='topprodsearch flex-column'>
                  <OrderSKUSearch
                    filterSearch={filterSearch}
                    searchNewEnq={setsearchPro}
                    searchParam={searchParam}
                    from="orders"
                    flag="Opportunity" //flag set
                    apiCall={ApiCalling}
                    apiurl="Opportunity"
                    searchByKeyword={searchByKeyword}
                  />
                </div>
              </th>
              <th>Expected Transfer Price</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody id="orDeskContain" ref={outerdivRef}>
            {tickets.length > 0 && tickets.map((ticket, index) => {
              let baseImg;
              ticket.images.map((item) => {
                if (item.baseImage === true) {
                  if (item.image.startsWith("products")) {
                    baseImg = item.image;
                  }
                  else {
                    let img = item.image.substr("41")
                    baseImg = img;
                  }
                }
              })
              return (
                <tr>
                  <td>
                    <div className='border-x'>
                      <img src={"https://s3.toolsvilla.com/" + baseImg} alt="img" className="px-2 product-i mx-1" />
                    </div>
                  </td>
                  <td className='fs-13 order_table_pname_cntn'>
                    <div className='border-x inline-initial'>
                      <a href='#popupDetail' onClick={() => detailnew(ticket?.productId?._id, ticket?.productId?.price, index)} className='prod-name'>{ticket?.productName}</a>
                      <div className='order_table_sku'>SKU:- {ticket?.SKU}</div>
                      <ul className="d-flex ord-crd mb-0">
                        {ticket?.combinationSet && ticket.combinationSet.length > 0 ? ticket.combinationSet[0]?.value.map((item, index) => {
                          return (
                            <>
                              <li className="bg-theme  p-1 m-1 text-white fs-11 corner ff_pop" key={index}>{ticket?.productId?.combination?.[0]?.value?.[index]} - {item}</li>
                            </>
                          )
                        }) : <></>}

                      </ul>
                      <a href='#popupDetail' onClick={() => detailnew(ticket?.productId?._id, ticket?.productId?.price, index)} className='detail-but'>
                        <button className='px-1 order_table_btn_details'>View Details</button>
                      </a>
                    </div>
                  </td>
                  <td>
                    <div className='border-x'>
                      {
                        <>
                          <p>
                            <i className="fa fa-inr" aria-hidden="true"></i>{Math.round(ticket?.expTransferPriceFrom)}
                            <span> - </span>
                            <i className="fa fa-inr" aria-hidden="true"></i>{Math.round(ticket?.expTransferPriceTo)}
                          </p>
                        </>
                      }
                    </div>
                  </td>
                  <td>
                    <div className='border-x'>
                      {/* <NavLink exact to={{
                        pathname:"/add-Product",
                        aboutProps:{
                              openProduct:"yes",
                              img:baseImg,
                              url: ticket.urlKey,
                              opportunityId: ticket._id
                            }
                        }} className="order_nav">
                      <button className='px-1 order_table_btn_details'>+ Add this product</button>
                    </NavLink> */}
                      <button className='p-1 order_table_btn_details' onClick={() => manifestDetailsVerify(index)}>+ Add this product</button>
                    </div>
                  </td>
                </tr>
              );
            })}
            {tickets.length == 0 ? (
              <tr>
                <td colspan="6">
                  <div
                    className="d-flex flex-column align-items-center justify-content-center text-center"
                    style={{
                      minHeight: "260px",
                      padding: "36px 20px",
                      background: "#f8fbfb",
                      border: "1px dashed #b7d0d0",
                      borderRadius: "12px",
                      margin: "16px",
                    }}
                  >
                    <div
                      className="d-flex align-items-center justify-content-center mb-3"
                      style={{
                        width: "64px",
                        height: "64px",
                        borderRadius: "50%",
                        background: "#e5f1f1",
                        color: "#165B5B",
                        fontSize: "28px",
                      }}
                    >
                      <i className="bi bi-box-seam"></i>
                    </div>
                    <h5 className="mb-2 ff_pop" style={{ color: "#165B5B", fontWeight: 600 }}>
                      {recordsMessage}
                    </h5>
                    <p className="mb-0 ff_pop" style={{ color: "#6c757d", fontSize: "14px", maxWidth: "420px" }}>
                      We could not find product opportunities right now.
                    </p>
                  </div>
                </td>
              </tr>
            ) : ""}
          </tbody>
        </table>
      </div >

      <PaginationNew
        number={totalRcord}
        paginate={paginate}
        activ={currentPage}
        comp={"support"}
      />

      <div class="d-flex justify-content-center" id="enNewLoader" ref={loaderDivRef}>
        <div
          style={{ display: ennewloader }}
        >
          <MainLoader/>
        </div>
      </div>

      <div id="popupDetail" className="overlay" style={{ "display": isDetailPopupVis }}>
        <Popup
          from="newOrder"
          description={productDetail[0].description}
          sdescription={productDetail[0].shortDescription}
          descriptionNew={productDetail[0].descriptionNew}
          specificationNew={productDetail[0].specificationNew}
          name={productDetail[0].productName}
          SKU={productDetail[0].SKU}
          pkgs={productDetail[0]?.pkgs}
          manufacturerName={productDetail[0]?.manufacturerName}
          popupVisibility={setpopupVisibilityDetail}
          images={productDetail[0].images}
          videos={productDetail[0].videos}
          curCombinationKeys={curCombinationKeys}
          curCombinationValues={curCombinationValues}
          flag="productOpportunitiesOrder"
          fixedImage={true}
        />
      </div>

      <Modal
        show={verifyManifestPopup}
        className="updtProPopModal orderManVerModal"
        centered
      >
        <Modal.Header>
          {/* SL-758 */}
          <div style={styles.verifyManifestPopup.headerDiv}>
            <>
              <button style={{ ...styles.verifyManifestPopup.headerBtns, background: currentStep === 0 ? '#c5d6d6' : null }} onClick={() => handleModalGoBack(0)}>Step 1</button>
              <button style={{ ...styles.verifyManifestPopup.headerBtns, background: currentStep === 1 ? '#c5d6d6' : null }} onClick={() => handleModalGoBack(1)}>Step 2</button>
              <button style={{ ...styles.verifyManifestPopup.headerBtns, background: currentStep === 2 ? '#c5d6d6' : null }} onClick={() => handleModalGoBack(2)}>Step 3</button>
            </>
          </div>
        </Modal.Header>
        <Modal.Body className="updtProPopModal_body p_3px">
          <a class="close mt-1" onClick={() => {
            dispatch(resetPackages())
            setVerifyManifestPopup(false)
            setCurrentStep(0)
          }}>
            &times;
          </a>
          <p style={styles.verifyManifestPopup.vtpPara}>{variables.variables.productOpportunitiesOrderTitles[currentStep]}</p>
          <Row className="">
            <div className="col-md-3 ">
              <div
                className="catalog-img-border"
                style={{
                  ...styles.verifyManifestPopup.imageBox,
                  background: `url(
                    "https://s3.toolsvilla.com/${currentClickedOrder?.images[0]?.image}"
                  )`,
                }}
              >
              </div>
            </div>
            <div className="col-md-9 py-1">
              <p className="product-name ff_pop" style={styles.verifyManifestPopup.pName}>{clickedProDets?.productName}</p>
              <p className="sku" style={styles.verifyManifestPopup.sku}>{clickedProDets?.SKU}</p>
              <p className="sku" style={styles.verifyManifestPopup.sku}>{clickedProDets?.manufacturerName}</p>
              <ul className="d-flex ord-crd mb-0">
                {curCombinationValues && curCombinationValues.length > 0 ? curCombinationValues[0]?.value.map((item, index) => {
                  return (
                    <>
                      <li className="bg-theme  p-1 m-1 text-white fs-11 corner ff_pop" key={index}>{curCombinationKeys[index]} - {item}</li>
                    </>
                  )
                }) : <></>}

              </ul>
            </div>
          </Row>

          {/* sl- 712 */}
          {/*  Confirm Details */}
          {currentStep === 0 && <>
            <Row className="mt-1 po-details-popup">
              <div className="" dangerouslySetInnerHTML={{ __html: clickedProDets?.description }}></div>
              {clickedProDets?.descriptionNew && clickedProDets?.descriptionNew.map((item, index) => {
                return <><div class="title fs-13 mt-2 bold">{item?.title} : </div><div
                  className="desc fs-13"
                  dangerouslySetInnerHTML={{
                    __html: item.description,
                  }} />
                  {item?.title == 'Specification' && clickedProDets?.specificationNew && clickedProDets?.specificationNew.length > 0 &&
                    clickedProDets?.specificationNew && clickedProDets?.specificationNew.map((item, index) => {
                      return <><div
                        className="desc fs-14"
                      >
                        <ul className='mb-0'>
                          <li>
                            {item?.type?.name} : {item?.name}{" "}{item?.unit}
                          </li>
                        </ul>
                      </div></>
                    })
                  }
                </>
              })}
              {!(clickedProDets?.descriptionNew || []).some(obj => obj.title === "Specifications" || obj.title === "Specification") && clickedProDets?.specificationNew && clickedProDets?.specificationNew != "[]" && clickedProDets?.specificationNew.length > 0 && <>
                <div>
                  <div class="title fs-14 mb-1 mt-2 bold">Specifications : </div>
                  {clickedProDets?.specificationNew && clickedProDets?.specificationNew != "[]" && clickedProDets?.specificationNew.map((item, index) => {
                    return <><div
                      className="desc fs-14"
                    >
                      <ul className='mb-0'>
                        <li>
                          {item?.type?.name} : {item?.name}{" "}{item?.unit}
                        </li>
                      </ul>
                    </div></>
                  })}
                </div></>}
              <div className="pd_desc">
                <div className="pd_long_desc">Short description</div>
                <div className='pd_description'>
                  <div id="popupSpecification " dangerouslySetInnerHTML={{ __html: clickedProDets?.shortDescription }}>
                  </div>
                </div>
              </div>
            </Row>

            <p style={styles.verifyManifestPopup.endBtnContainer}>
              <button style={styles.verifyManifestPopup.submitBtn} onClick={() => setCurrentStep(1)}>Confirm & Proceed</button>
            </p>
          </>}


          {/* Transfer Price Update */}
          {
            currentStep === 1 && <>
              <Row className="text-center mt-1">
                <div className="col-12 ">
                  <div style={styles.verifyManifestPopup.expTraPriceTag}>
                    Expected Transfer Price : <i className="fa fa-inr" aria-hidden="true"></i>{Math.round(currentClickedOrder?.expTransferPriceFrom)} - <i className="fa fa-inr" aria-hidden="true"></i>{Math.round(currentClickedOrder?.expTransferPriceTo)}
                  </div>
                  <form className="">
                    <label style={styles.verifyManifestPopup.label}>
                      <span className="transfer-price ff_pop my-auto fw-800" style={styles.verifyManifestPopup.tpTitle}>
                        Transfer Price (incl. {gst}% GST) :
                      </span>
                      <span className="position-relative ms-1" style={styles.verifyManifestPopup.sUpdateContainer}>
                        <input
                          type="number"
                          autocomplete="off"
                          minLength="1"
                          value={verTrPrice}
                          style={styles.verifyManifestPopup.tpInput}
                          required
                          disabled={tpDisabled}
                          onChange={(e) => setVerTrPrice(e.target.value)}
                          onWheel={(e) => e.target.blur()}
                        />
                        <span style={styles.verifyManifestPopup.rsLabel}><i className="bi bi-currency-rupee" style={{ fontWeight: 'bold !important' }}></i></span>
                        <span style={styles.verifyManifestPopup.tpEdit}><i className="bi bi-pencil" style={{ fontWeight: 'bold !important' }} onClick={() => setTpDisabled(false)}></i></span>
                      </span>
                    </label>
                    <label style={styles.verifyManifestPopup.label}>
                      <span className="transfer-price ff_pop my-auto fw-800" style={styles.verifyManifestPopup.tpTitle}>
                        Select Gst % :
                      </span>
                      <span className="position-relative ms-1" style={styles.verifyManifestPopup.sUpdateContainer}>
                        <select
                          size="sm"
                          style={styles.verifyManifestPopup.gstInput}
                          value={gst}
                          onChange={(e) => setGst(e.target.value)}
                        >
                          {variables?.variables?.gstValues.map((item, index) => {
                            return (
                              <option key={index} value={item}>
                                {item}
                              </option>
                            );
                          })}
                        </select>
                      </span>
                    </label>
                  </form>
                </div>
              </Row>
              <p style={styles.verifyManifestPopup.endBtnContainer}>
                <button style={styles.verifyManifestPopup.backBtn} onClick={() => setCurrentStep(0)}>Back</button>
                <button className='ms-2' style={styles.verifyManifestPopup.submitBtn} onClick={() => handlePriceSubmit()}>Confirm and Proceed</button>
              </p>
            </>
          }

          {/* Stock Details */}
          {/* sl-758 */}
          {/* Transfer Price Update */}
          {
            currentStep === 2 && <>
              <Row className="text-center mt-1">
                <div className="col-12 ">
                  <form className="">
                    <label style={styles.verifyManifestPopup.label}>
                      <span className="transfer-price ff_pop my-auto fw-800" style={styles.verifyManifestPopup.tpTitle}>
                        Current Stock :
                      </span>
                      <span className="position-relative ms-1" style={styles.verifyManifestPopup.sUpdateContainer}>
                        <input
                          type="number"
                          autocomplete="off"
                          minLength="1"
                          value={currentStock}
                          style={styles.verifyManifestPopup.cStockInput}
                          required
                          disabled={stockDisabled}
                          onChange={(e) => setCurrentStock(e.target.value)}
                          onWheel={(e) => e.target.blur()}
                        />
                        <span style={styles.verifyManifestPopup.tpEdit}><i className="bi bi-pencil" style={{ fontWeight: 'bold !important' }} onClick={() => setStockDisabled(false)}></i></span>
                      </span>
                    </label>
                  </form>
                </div>
              </Row>
              <p style={styles.verifyManifestPopup.endBtnContainer}>
                <button style={styles.verifyManifestPopup.backBtn} onClick={() => setCurrentStep(1)}>Back</button>
                <button className='ms-2' style={styles.verifyManifestPopup.submitBtn} onClick={() => submitVerifyManifest()}>Submit</button>
              </p>
            </>
          }


        </Modal.Body>
      </Modal>

      {
        isSuccessPopupVisible ?
          <SuccessPopup product={{ name: clickedProDets?.productName, ...clickedProDets }} onClose={() => setIsSuccessPopupVisible(false)} msg={"Toolsvilla team will review your price request,once approved, the product will be added to your inventory."} titleMsg={"Your Request has been submitted"} /> : <></>
      }
    </div >
  );
}

export default ProductOpportunities;